module.exports = __webpack_public_path__ + "static/media/howz-logo@2x.a88925e8.png";